var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-card"},[_c('div',{staticClass:"header"},[_c('h4',[_vm._v("Proveedores acreedores (a quienes se les debe)")]),_c('chart-options',{attrs:{"store_name":"acreedores","total_registros_text":_vm.total_registros_text,"registros_para_mostrar":_vm.providers_formated}})],1),_c('acreedores')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }